import fetchClient from '@eureca/recruiter-api-sdk/client';

export interface JobContentAssetUploadResult {
  url: string;
  fileName: string;
  fileType: 'pdf' | 'video';
}

export class JobContentAssetUploadError extends Error {
  readonly name = 'JobContentAssetUploadError';
  constructor(
    message: string,
    readonly status: number
  ) {
    super(message);
  }
}

/**
 * Faz upload da mídia (PDF/MP4) de uma etapa de conteúdo via
 * `POST /jobs/:id/content-asset` (multipart-thru-BFF → S3, leitura pública).
 * Retorna a URL pública + nome original + tipo, que o container grava no
 * `module.config` (`{ fileUrl, fileName, fileType }`) no próximo save.
 */
export async function uploadJobContentAsset(
  jobId: string,
  file: File
): Promise<JobContentAssetUploadResult> {
  const formData = new FormData();
  formData.append('file', file, file.name);
  const res = await fetchClient<JobContentAssetUploadResult>({
    method: 'POST',
    url: `/jobs/${jobId}/content-asset`,
    data: formData,
  });
  if (res.error) {
    throw new JobContentAssetUploadError(
      `Failed to upload content asset (status ${res.error.status})`,
      res.error.status
    );
  }
  return res.data;
}
